import { defaultCurrencyConfig } from './currency';
import { defaultDateConfig } from './date';
import { defaultMonetaryValueConfig } from './monetary-value';
import { defaultNumberConfig } from './number';
import { defaultPersonNameConfig } from './person-name';
/**
 * The default config options for I18N.
 */
export const defaultConfig = {
    languageTag: 'en',
    date: defaultDateConfig,
    number: defaultNumberConfig,
    currency: defaultCurrencyConfig,
    monetaryValue: defaultMonetaryValueConfig,
    personName: defaultPersonNameConfig
};
//# sourceMappingURL=config.js.map